import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_DATA, SITE_URL } from '../data/Constants';

const SEO = ({ title, description, canonical, type = 'website', image, keywords }) => {
   const siteTitle = title 
      ? (title.includes(SITE_DATA.brandName) ? title : `${title} | ${SITE_DATA.brandName}`) 
      : SITE_DATA.brandName;
   const siteDescription = description || "Premium fireplaces, grills, and outdoor living products since 2001. Serving Langley and the Greater Vancouver area.";
   const siteImage = image || `${SITE_URL}${SITE_DATA.brandLogo}`;
   const siteUrl = canonical || (typeof window !== 'undefined' ? window.location.href : SITE_URL);

   return (
      <Helmet>
         {/* Standard Metadata */}
         <title>{siteTitle}</title>
         <meta name="description" content={siteDescription} />
         {keywords && <meta name="keywords" content={keywords} />}

         {/* Geo-Targeting Metadata */}
         <meta name="geo.region" content="CA-BC" />
         <meta name="geo.placename" content="Langley" />
         <meta name="geo.position" content="49.113411;-122.649938" />
         <meta name="ICBM" content="49.113411, -122.649938" />

         {/* Open Graph / Facebook */}
         <meta property="og:type" content={type} />
         <meta property="og:title" content={siteTitle} />
         <meta property="og:description" content={siteDescription} />
         <meta property="og:image" content={siteImage} />
         <meta property="og:url" content={siteUrl} />
         <meta property="og:locale" content="en_CA" />
         <meta property="og:site_name" content={SITE_DATA.brandName} />

         {/* Twitter */}
         <meta name="twitter:card" content="summary_large_image" />
         <meta name="twitter:title" content={siteTitle} />
         <meta name="twitter:description" content={siteDescription} />
         <meta name="twitter:image" content={siteImage} />

         {/* Canonical Link */}
         <link rel="canonical" href={siteUrl} />
         
         {/* Favicon */}
         <link rel="icon" type="image/png" href={`${SITE_URL}/images/logo/favicon.png`} />
         <link rel="apple-touch-icon" href={`${SITE_URL}/images/logo/apple-touch-icon.png`} />
      </Helmet>
   );
};

export default SEO;
